<template>
  <mdb-container fluid class="card-carousel-wrapper">
    <mdb-row class="brow3">
      <div class="card-carousel--nav__left"
        @click="moveCarousel(-1)"
        :disabled="atHeadOfList"/>
      <mdb-col class="abcol2">
        <div class="card-carousel">
          <div class="card-carousel--overflow-container">
            <div class="card-carousel-cards"
              :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
              <div class="card-carousel--card" v-for="item in listArray" :key="item.id" >
                <router-link class="routerlink" :to="`/estimate/${item.id}`">
                  <img :src="item.srcImg" />
                  <div class="card-carousel--card--footer">
                    <p class="card-footer-text footer_height">{{ item.name }}</p>
                    <p class="card-footer-text">월 {{ item.monthlyPrice }}만원</p>
                    <p class="card-footer-text">(금리 {{ item.interestRate }}%)</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </mdb-col>
      <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
    </mdb-row>
  </mdb-container>
</template>

<script>
export default {
  data() {
    return {
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 260, // 버튼클릭시 이동 사이즈
    };
  },
  props: {
    listArray: {
      type: Array,
      required: true,
    },
    pageSize: {
      type: Number,
      required: false,
      default: 12, // 한페이지에 표시 할 이미지 개수
    },
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.pageSize - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  methods: {
    moveCarousel(direction) {
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  },
};
</script>

<style scoped>
body {
  background: white;
  color: black;
  font-family: 'Source Sans Pro', sans-serif;
}

.brow3 {
  max-width: 1348px;
  max-height: 500px;
  align-items: center;
  margin: auto auto;
}

@media (max-width: 1180px){
  .brow3 {
    max-width: 1134px;
    max-height: 500px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: auto auto;
    overflow: hidden;
  }
}

.abcol2 {
  max-width: 100%;
  height: auto;
  align-items: center;
  margin: 0px 0px;
  padding-left: 0px;
  padding-right: 0px;
  overflow: hidden;
}

.card-carousel-wrapper {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  max-width: 1348px;
  color: black;
  overflow: hidden;
}

.card-carousel {
  display: flex;
  justify-content: center;
  max-width: 1248px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.card-carousel--overflow-container {
  overflow: hidden;
}

.card-carousel--nav__left[disabled], .card-carousel--nav__right[disabled] {
  opacity: 1.3;
  border-color: black;
}
.card-carousel--nav__left {
  transform: rotate(-135deg);
  display: inline-block;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border-top: 4px solid;
  border-right: 4px solid;
  cursor: pointer;
  margin-left: 0px;
  opacity: 1.2;
  border-color: black;
  margin-top: 0%;
  margin-right: 0px;
  margin-left: 33px;
}

.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}

.card-carousel--nav__right {
  transform: rotate(45deg);
  display: inline-block;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border-top: 4px solid;
  border-right: 4px solid;
  cursor: pointer;
  margin-right: 0px;
  margin-top: 0%;
  opacity: 1.2;
  border-color: black;
  margin-right: 33px;
  margin-left: 0px;
  padding-right: 0px;
}

.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
}

.card-carousel-cards .card-carousel--card {
  margin: auto 23px;
  cursor: pointer;
  background-color: white;
  border-radius: 0px;
  z-index: 3;
  margin-bottom: 0px;
}

.card-carousel-cards .card-carousel--card:first-child {
  margin-left: -10px;
}

.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 10px;
}

.card-carousel-cards .card-carousel--card img {
  vertical-align: bottom;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  transition: opacity 150ms linear;
  user-select: none;
  max-width: 215px;
  max-height: 107px;
}

.card-carousel-cards .card-carousel--card img:hover {
  opacity: .7;
}

.card-carousel-cards .card-carousel--card--footer {
  border-top: 0;
  padding: 7px 15px;
}

.card-carousel-cards .card-carousel--card--footer p {
  padding: 3px 0;
  margin: 0;
  margin-bottom: 2px;
  font-weight: 600;
  color: black;
  user-select: none;
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: bold;
}

.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
  font-weight: 700;
  background: black(111, 112, 114, 0.06);
  display: inline-block;
  position: relative;
  margin-left:auto;
  margin-right: auto;
  align-content: center;
  color: #ffba00;
  font-size: 20px;
  font-family: "Proxima Nova";
  font-weight: bold;
  align-items: center;
}

h1 {
  font-size: 3.6em;
  font-weight: 100;
  text-align: center;
  margin-bottom: 0;
  color:  black;
}

.card-footer-text {
  align-items: center;
  margin: auto auto;
}
.footer_height {
  height: 35px;
}
</style>
